module.exports = __webpack_public_path__ + "static/media/bloodscreen.2116b563.png";